(function(){
    'use strict';

    angular.module('elogbooks.common.labour-lines', []);
})();
